import log from 'loglevel'

log.setLevel((import.meta.env.VITE_LOG_LEVEL as log.LogLevelDesc) ?? (import.meta.env.PROD ? 'warn' : 'trace'))

export default log
